module.exports = __webpack_public_path__ + "img/charity_33.2565f204.png";